import { call, select } from 'redux-saga/effects';
import { CANCEL } from 'redux-saga';
import {
  brandSelector,
  channelSelector,
  languageSelector,
  proxyPrefixSelector,
  userTokenSelector,
} from '../../reducers/app/params';
import { contentAPIPrefixSelector } from '../../reducers/app/configuration';
import {
  PROJECT_KEY,
  ENTITY,
  QUERY,
  CHANNEL_CONFIG_MAP,
} from '../../../constants/content';
import { HTTP_HEADERS, COMMON_CONFIG_URL } from '../../../constants/api';
import {
  APP_STORE_REVIEW_HEADER_NAME,
  APP_STORE_REVIEW_HEADER_VALUE,
} from '../../../constants/appStoreReview';
import { isLocalGameLaunchMode } from '../../reducers/app/initialization';
import { initAPI, getAPI } from '../../../services/api';

export function* initializeAPI() {
  const proxyPrefix = yield select(proxyPrefixSelector);
  yield call(initAPI, { baseUrl: proxyPrefix });
}

export function* getCommonHeaders() {
  const channel = yield select(channelSelector);
  const brand = yield select(brandSelector);
  const language = yield select(languageSelector);
  const token = yield select(userTokenSelector);
  const localGameLaunchMode = yield select(isLocalGameLaunchMode);

  return {
    [HTTP_HEADERS.CONTENT_TYPE]: 'application/json',
    [HTTP_HEADERS.CHANNEL]: channel,
    [HTTP_HEADERS.BRAND]: brand,
    [HTTP_HEADERS.LANGUAGE]: language,
    ...(token ? { [HTTP_HEADERS.AUTHORIZATION]: `Token ${token}` } : {}),
    ...(localGameLaunchMode
      ? { [APP_STORE_REVIEW_HEADER_NAME]: APP_STORE_REVIEW_HEADER_VALUE }
      : {}),
  };
}

// bonuses content
export function* getBonusesContent() {
  const contentAPIPrefix = yield select(contentAPIPrefixSelector);
  const language = yield select(languageSelector);
  const brand = yield select(brandSelector);
  const channel = yield select(channelSelector);

  const params = new URLSearchParams();

  params.set(QUERY.BRANDS, brand.toUpperCase());
  params.set(QUERY.PROJECT, PROJECT_KEY);
  params.set(QUERY.CHANNELS, CHANNEL_CONFIG_MAP[channel.toUpperCase()]);
  params.set(QUERY.LANGUAGE_ID, language);

  const queryString = `?${params.toString()}`;
  const url = `/${ENTITY.BONUSES}${queryString}`;

  return yield call(getAPI().fetch, url, {
    baseUrl: contentAPIPrefix,
    abortMethodName: CANCEL,
  });
}

export function* getCommonConfiguration() {
  return yield call(getAPI().fetch, COMMON_CONFIG_URL, {
    abortMethodName: CANCEL,
  });
}

// EVA API

// Games & categories
export function* getCommonConfig() {
  const headers = yield call(getCommonHeaders);

  return yield call(getAPI().lobby.get, { headers, abortMethodName: CANCEL });
}
